export const FETCH_FILE_FOR_DOWNLOAD_FAILURE = 'FETCH_FILE_FOR_DOWNLOAD_FAILURE';
export const FETCH_FILE_FOR_DOWNLOAD_REQUEST = 'FETCH_FILE_FOR_DOWNLOAD_REQUEST';
export const FETCH_FILE_FOR_DOWNLOAD_SUCCESS = 'FETCH_FILE_FOR_DOWNLOAD_SUCCESS';

export const FETCH_FILE_FOR_OBJECT_URL_FAILURE = 'FETCH_FILE_FOR_OBJECT_URL_FAILURE';
export const FETCH_FILE_FOR_OBJECT_URL_REQUEST = 'FETCH_FILE_FOR_OBJECT_URL_REQUEST';
export const FETCH_FILE_FOR_OBJECT_URL_SUCCESS = 'FETCH_FILE_FOR_OBJECT_URL_SUCCESS';
